import { decodeBase64Url, encodeBase64Url, toArrayBuffer } from '@tadpoles/web-credentials';
const AesGcmAlgorithmName = 'AES-GCM';
const AesKeyLength = 256;
const GcmNonceLength = 12;
const CurrentWrappedKeyVersion = 1;
function requireCrypto() {
    if (typeof crypto === 'undefined' || typeof crypto.subtle === 'undefined') {
        throw new Error('WebCrypto is not available in this environment.');
    }
    return crypto;
}
function createNonce() {
    return requireCrypto().getRandomValues(new Uint8Array(GcmNonceLength));
}
function createAesGcmAlgorithm(iv, aad) {
    if (aad === undefined) {
        return {
            iv: toArrayBuffer(iv),
            name: AesGcmAlgorithmName
        };
    }
    return {
        additionalData: toArrayBuffer(aad),
        iv: toArrayBuffer(iv),
        name: AesGcmAlgorithmName
    };
}
export async function createRandomDataKey() {
    return await requireCrypto().subtle.generateKey({
        length: AesKeyLength,
        name: AesGcmAlgorithmName
    }, true, ['encrypt', 'decrypt']);
}
export async function wrapDataKey(wrappingKey, dataKey) {
    const nonce = createNonce();
    const wrappedKey = await requireCrypto().subtle.wrapKey('raw', dataKey, wrappingKey, createAesGcmAlgorithm(nonce));
    return {
        wrapNonce: encodeBase64Url(nonce),
        wrappedKey: encodeBase64Url(wrappedKey)
    };
}
export async function unwrapDataKey(wrappingKey, record) {
    if (record.wrapAlgorithm !== AesGcmAlgorithmName) {
        throw new Error(`Unsupported wrapped key algorithm "${record.wrapAlgorithm}".`);
    }
    if (record.keyVersion !== CurrentWrappedKeyVersion) {
        throw new Error(`Unsupported wrapped key version "${record.keyVersion}".`);
    }
    return await requireCrypto().subtle.unwrapKey('raw', toArrayBuffer(decodeBase64Url(record.wrappedKey)), wrappingKey, createAesGcmAlgorithm(decodeBase64Url(record.wrapNonce)), {
        length: AesKeyLength,
        name: AesGcmAlgorithmName
    }, false, ['encrypt', 'decrypt']);
}
export async function encrypt(request) {
    const nonce = createNonce();
    const ciphertext = await requireCrypto().subtle.encrypt(createAesGcmAlgorithm(nonce, request.aad), request.key, toArrayBuffer(request.plaintext));
    return {
        ciphertext: new Uint8Array(ciphertext),
        nonce
    };
}
export async function decrypt(request) {
    const plaintext = await requireCrypto().subtle.decrypt(createAesGcmAlgorithm(request.nonce, request.aad), request.key, toArrayBuffer(request.ciphertext));
    return new Uint8Array(plaintext);
}
